module.exports = __webpack_public_path__ + "img/visa-master.3ec12a48.svg";